module.exports = __webpack_public_path__ + "static/media/form.b0168bea.svg";